import { TbCategory } from 'react-icons/tb'

import { TopMenu } from '../Components/TopMenu'
import { DICTIONARY_SEARCH_FIELDS } from '../Contracts/DictionaryFields'
import { CRM_LIST_COLUMNS, crmListFields } from '../Contracts/CrmListFields'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Довідник «Типи справ» (сім'я `CrmList`, `SPEC-007` §4).
 *
 * Вид справи в її картці (`SPEC-011`).
 *
 * Сторінку бачить лише той, кому бек дає створення довідників, тобто
 * адміністратор (`pageConfig.accessFn`, `SPEC-007` §7.1); читати довідник для
 * селектів може кожен.
 */
export const ListActivityTypeResource: IResourceConfig = {
    title: 'Типи справ',
    fields: crmListFields(),
    table: {
        showColumns: CRM_LIST_COLUMNS,
    },
    filter: {
        includeFields: ['id', 'title', 'code'],
    },
    places: {
        top: <TopMenu current="activity-types" />,
    },
    restUrl: '/services/activity_types',
    pageUrl: '/settings/activity-types',
    pageConfig: {
        title: 'Типи справ',
        icon: <TbCategory />,
        accessFn: CheckDictionaryPageAccessTask,
    },
    settings: {
        searchFields: DICTIONARY_SEARCH_FIELDS,
    },
}
